import { Box } from '@mui/material';
import Calendar from '../../features/Calendar/Calendar';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTopics, loadTopicsRequest } from '../../../redux/topicRedux';
import Topics from '../../features/Topics/Topics';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../../../config';
import {
  getRepairOrders,
  loadRepairOrdersRequest,
} from '../../../redux/repairOrdersRedux';
import RepairOrder from '../../features/RepairOrder/RepairOrder';
const SLIDE_MS = 30_000;
const socket = io(SOCKET_URL);
const Slider = () => {
  const dispatch = useDispatch();
  const topics = useSelector((state) => getTopics(state));
  const repairOrders = useSelector((state) => getRepairOrders(state));
  const timeRef = useRef(null);
  // const [index, setIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const clearTime = () => {
    if (timeRef.current) {
      clearTimeout(timeRef.current);
      timeRef.current = null;
    }
  };
  const startTime = (slidesCount) => {
    clearTime();
    timeRef.current = setTimeout(() => {
      setActiveIndex((prev) => (prev + 1) % slidesCount);
    }, SLIDE_MS);
  };

  const slides = useMemo(
    () => [
      {
        key: 'topics',
        node: (
          <Box sx={{ height: '100%' }}>
            <Topics
              topics={topics.filter((t) => t.category === 'CURRENT')}
              temat="Brak wiadomości do wyświetlenia"
              naglowek="Tematy bieżące"
              buttonText="Dodaj wiadomość"
              category="CURRENT"
              sliderBool={true}
            />
          </Box>
        ),
      },
      {
        key: 'calendar',
        node: <Calendar maxEvents={10} heightBool={true} />,
      },
      {
        key: 'incident',
        node: (
          <Box sx={{ height: '100%' }}>
            <Topics
              topics={topics.filter((t) => t.category === 'INCIDENT')}
              temat="Brak incydentów do wyświetlenia"
              naglowek="Incydenty"
              buttonText="Dodaj incydent"
              category="INCIDENT"
              sliderBool={true}
            />
          </Box>
        ),
      },
      {
        key: 'repairOrders',
        node: (
          <Box sx={{ height: '100%' }}>
            <RepairOrder
              orders={repairOrders}
              temat="Brak otwartych zleceń naprawy"
              naglowek="Zlecenia naprawy"
              buttonText="Dodaj zlecenie naprawy"
              sliderBool={true}
            />
          </Box>
        ),
      },
    ],
    [topics, repairOrders],
  );

  const keyToIndex = useMemo(() => {
    const map = {};
    slides.forEach((s, i) => (map[s.key] = i));
    return map;
  }, [slides]);

  const goTo = (key) => {
    const idx = keyToIndex[key];
    if (idx === undefined) return;
    setActiveIndex(idx);
    startTime(slides.length); // reset licznika
  };

  useEffect(() => {
    const start = async () => {
      await dispatch(loadTopicsRequest());
      await dispatch(loadRepairOrdersRequest());
    };
    start();
  }, [dispatch]);

  useEffect(() => {
    startTime(slides.length);
    return clearTime;
  }, [activeIndex, slides.length]);

  useEffect(() => {
    socket.on('newTopic', (topic) => {
      console.log('Otrzymano nowy temat:', topic);
      dispatch(loadTopicsRequest());
      goTo('topics');
    });

    socket.on('closeCurrentTopic', (topicId) => {
      console.log('Temat został zamknięty:', topicId);
      dispatch(loadTopicsRequest());
    });

    socket.on('newEvent', (event) => {
      console.log('Otrzymano nowe wydarzenie:', event);
      goTo('calendar');
    });

    socket.on('deletedEvent', (eventId) => {
      console.log('Usunięto wydarzenie:', eventId);
      goTo('calendar');
    });

    socket.on('newOrder', (order) => {
      console.log('Otrzymano nowe zlecenie:', order);
      dispatch(loadRepairOrdersRequest());
      goTo('repairOrders');
    });

    socket.on('segregation', (segregation) => {
      console.log('Otrzymano nowe segregowanie:', segregation);
      dispatch(loadRepairOrdersRequest());
      goTo('repairOrders');
    });

    return () => {
      socket.off('newTopic');
      socket.off('closeCurrentTopic');
      socket.off('newEvent');
      socket.off('deletedEvent');
      socket.off('newOrder');
      socket.off('segregation');
    };
  }, [dispatch]);
  return (
    <Box sx={{ height: '90vh', width: '98vw', mt: 5, padding: 2 }}>
      {/* <Box sx={{ height: '100%', width: '100%', overflow: 'hidden' }}>
        <Box
          sx={{
            height: '100%',
            width: '200%',
            display: 'flex',
            transform: index === 0 ? 'translateX(0%)' : 'translateX(-50%)',
            transition: 'transform 600ms ease-in-out',
          }}
        >
          <Box sx={{ width: '50%', height: '100%' }}>
            <Box sx={{ height: '100%' }}>
              <Topics
                topics={topics.filter((t) => t.category === 'CURRENT')}
                temat="Brak wiadomości do wyświetlenia"
                naglowek="Tematy bieżące"
                buttonText="Dodaj wiadomość"
                category="CURRENT"
              />
            </Box>
          </Box>

          <Box sx={{ width: '50%', height: '100%' }}>
            <Calendar maxEvents={10} heightBool={true} />
          </Box>
        </Box>
      </Box> */}
      <Box sx={{ height: '100%', width: '100%', overflow: 'hidden' }}>
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            mt: 5,
            transform: `translateX(-${activeIndex * 100}%)`,
            transition: 'transform 600ms ease-in-out',
          }}
        >
          {slides.map((s) => (
            <Box key={s.key} sx={{ flex: '0 0 100%', height: '100%' }}>
              {s.node}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Slider;
